module.exports = __webpack_public_path__ + "static/media/home-ana-awards-future.2ec6ef7d.png";